module.exports = __webpack_public_path__ + "img/icon-fabuchengguo.29741a1.png";